import { cn } from "@kyan/ui";
import React from "react";

export interface OrderbookTableRowEffectProps {
  total: number;
  maxTotal: number;
  isBuys: boolean;
}

export const OrderbookTableRowEffect: React.FC<
  OrderbookTableRowEffectProps
> = ({ total, maxTotal, isBuys }) => {
  return (
    <div
      style={{ width: `${((total / maxTotal) * 100).toString()}%` }}
      className={cn("absolute inset-y-0 right-0 bg-gradient-to-r opacity-60", {
        "to-error": !isBuys,
        "to-success": isBuys,
      })}
    />
  );
};
